/*
Sohel 09/19/2022 3075154998 Data Manager Matching Logic ->Integrated API,Added System Notes and Suggested Changes
Suresh peddavoora 10/26/2022 3075154998  Added Class Name for Text Fields and Buttons
Suresh Peddavoora 10/31/2022 3075154998  Changed class name for Text Fields
Raghu Arun Kumar 11/02/2022 3075154998  Responsive alignment fixes
Lalitha  11/9/2022  3075154998 Rename Button Clear to Reset
*/
import React, {useEffect, useContext, useState} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import SearchMatchingLogicTable from './SearchMatchingLogic';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {RECORD_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import {getDropDownData} from '../../../../../redux/reducers/EnableFramework/Filter';

import * as Yup from 'yup';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const SearchMatchingLogic = ({setValue}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const {dropDownData} = useSelector(({filter}) => filter);

  useEffect(() => {
    dispatch(getDropDownData());
  }, []);

  const schema = Yup.object().shape({
    code: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });

  const initialValues = {
    code: '',
    recordType: null,
    description: '',
  };

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };

  return (
    <>
      <div className={`mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              touched,
              errors,
              values,
              setFieldValue,
              handleChange,
              handleBlur,
              handleReset,
            } = props;
            return (
              <div className="standard-field-textfields">
                <Form autoComplete="off" noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={3} md={4} sm={6} lg={2} xl={2} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        placeholder={`Enter Code`}
                        label="Code"
                        name="code"
                        value={values?.code?.toUpperCase()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      <FormHelperText>{touched.code && errors.code && errors.code} </FormHelperText>
                    </Grid>
                    <Grid item xs={3} md={4} sm={6} lg={4} xl={4} className="form-group">
                      <TextField
                        margin="dense"
                        variant="standard"
                        name="description"
                        placeholder={`Enter Description`}
                        label="Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={4} md={4} sm={6} lg={3} xl={3} className="pl-md-1 form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="recordType"
                        id="recordType"
                        size="small"
                        value={values.recordType}
                        options={getOptions(RECORD_TYPE, dropDownData)}
                        getOptionDisabled={(option) => option.valueCode === null}
                        getOptionLabel={(option) => {
                          return option && option.valueCode && option.value ?
                            option.valueCode + ' - ' + option.value :
                            option.value === null ?
                              option.valueCode :
                              option.value ?
                                option.value :
                                '';
                        }}
                        onChange={(e, value) => {
                          handleChange(e);
                          setFieldValue('recordType', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              error={touched.recordType && errors.recordType}
                              variant="standard"
                              margin="dense"
                              label="Record Type"
                              placeholder="Select Record Type"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                    <Grid item xs={3} md={12} sm={6} lg={2} xl={2} className="form-group">
                      <div className="global-buttons">
                        <Button
                          variant="outlined"
                          className={`reset-btn mx-1 ${classes.buttonRoot}`}
                          onClick={() => {
                            handleReset();
                          }}
                        >
                    Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn mx-1 ${classes.buttonRoot}`}
                        >
                    Search
                        </Button>
                      </div>
                    </Grid>
                  </Grid>

                </Form>
              </div>
            );
          }}
        </Formik>
        <Grid>
          <SearchMatchingLogicTable
            searchData={searchData}
            setSearchData={setSearchData}
            submit={submit}
            setSubmit={setSubmit}
            setValue={setValue}
          />
        </Grid>
      </div>
    </>
  );
};
export default SearchMatchingLogic;
